<template>
    <app-layout class="home-cover">
        <a href="#form-container-id" class="bg-navy" v-if="landing.cover">
        <img class="cover-image md:hidden cursor-pointer" :src="landing.cover.mobile" :alt="landing.cover.alt">
        <img class="cover-image object-cover md:block hidden cursor-pointer w-full max-h-[700px]" :src="landing.cover.desktop" :alt="landing.cover.alt">
        <div class="floating-box">
          <h1 class="text-[28px] lg:text-[40px] font-extrabold text-white" v-html="landing.cover.title"></h1>
          <div class="text-base lg:text-[20px] font-medium text-white mt-3 w-[350px]" v-html="landing.cover.description"></div>
          <v-btn @click.prevent="scrollToForm" rounded elevation="0" color="secondary" height="50"
            class="avm-btn avm-btn--medium mt-4">
            {{ $t('home.reserve-now') }}
          </v-btn>
        </div>

        </a>
        <div class="destination-grid-container">
            <div class="container-1240 mt-">
                <h1 class="heading-1 mb-5">{{landing.title}}</h1>
                <p class="text-base lg:text-lg font-black">{{landing.subtitle}}</p>
                <div class="grid-container gap-3 hidden md:grid">
                    <div v-for="(image, index) in landing.gallery" :key="index" :class="`item${index + 1} rounded-xlg`">
                        <img :src="image.src" :alt="image.alt" class="rounded-xlg">
                    </div>
                </div>
                <app-horizontal-carousel class="md:hidden ml-0 mt-5">
                    <div v-for="(image, index) in landing.gallery" :key="index" class="img-carousel mr-3 rounded-xlg h-56">
                        <v-img :src="image.src" :alt="image.alt" class="rounded-xlg size-full" />
                    </div>
                </app-horizontal-carousel>
            </div>
            <div class="container-1240 md:flex items-start gap-12 md:pt-16 pt-10">
                <div class="flex-1">
                    <div class="md:mb-12 mb-6">
                        <h2 class="mb-3 heading-2-black">{{ $t('you_will_leave') }}</h2>
                        <p>{{landing.destination_info}}</p>
                    </div>
                    <div class="md:mb-5">
                        <div>
                            <h5 class="mb-3 heading-5">{{ $t('included') }}</h5>
                            <div v-for="(info, index) in landing.info_included" :key="index" class="flex gap-5 md:mb-5 mb-3">
                                <img src="/img/icons/check.svg" alt="Icono">
                                <p>{{ info }}</p>
                            </div>
                        </div>
                        <div class="pt-4">
                            <h5 class="heading-5">{{ $t('not_included') }}</h5>
                            <ul class="list-disc mt-2 pl-5">
                                <li v-for="(info, index) in  landing.info_not_included" :key="index">{{ info }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div id="form-container-id"></div>
                <div class="my-5" v-if="itineraries.length">
                    <app-compact-search
                    :cityDestinationCode="landing.code"
                    :itineraries="itineraries.map(itinerary => itinerary.days)"
                    :extra-no-promo-percentage="landing.extra_no_promo_percentage">
                    </app-compact-search>
                </div>
            </div>
            <div class="md:pt-16 py-10">
                <div class="container-1240">
                    <app-itinerary
                    v-if="itineraries.length"
                    :itineraries="itineraries"
                    :itinerary-selected="itinerarySelected"
                    :itinerary-image="itineraries[itinerarySelected] ? itineraries[itinerarySelected].map_image : ''"
                    :update-selected="updateItinerarySelected"
                    :landing="landing"
                    >
                    </app-itinerary>
                    <div v-else class="text-center py-10 bg-navy text-white rounded-2xl">
                        <h3 class="text-2xl font-bold mb-3">📍 {{ $t('title_no_itineraries') }}</h3>
                        <p class="text-lg">{{ $t('subtitle_no_itineraries') }}</p>
                    </div>
                </div>
            </div>
            <div class="md:py-16 py-10">
                <div class="container-1240">
                    <h2 class="mb-3 heading-2-black">{{$t('the_hotels_title')}}</h2>
                    <p>{{$t('the_hotels_subtitle')}}</p>
                    <div class="hidden md:grid grid-cols-3 gap-3 mt-8">
                        <div v-for="(image, index) in hotelImages" :key="index" :class="`item${index + 1} rounded-xlg`" class="hotel-box">
                            <img :src="'/storage/' + image" :alt="image.altImages" class="rounded-xlg w-full h-full object-cover">
                        </div>
                    </div>
                    <app-horizontal-carousel class="md:hidden ml-0 mt-5 h-full">
                        <div v-for="(image, index) in hotelImages" :key="index" class="w-64 mr-3 rounded-xlg h-48">
                            <v-img :src="'/storage/' + image" :alt="image.altImages" class="rounded-xlg h-full object-cover w-full" />
                        </div>
                    </app-horizontal-carousel>
                </div>
            </div>
            <div class="bg-paleGrey md:py-16 py-10 px-4">
                <div class="container-1240 flex flex-col md:flex-row justify-center items-baseline md:gap-8 gap-6">
                    <div class="flex-1">
                    <h3 class="mb-2 heading-2-small">{{ $t('payment_module.title_left') }}</h3>
                    <p>{{ $t('payment_module.subtitle_left') }}</p>
                    </div>
                    <div class="flex-1">
                    <h3 class="mb-2 heading-2-small">{{ $t('payment_module.title_right') }}</h3>
                    <slot name="payment-module-sub-right"></slot>

                    </div>
                </div>
            </div>
            <!-- <reviews-module></reviews-module> -->
            <section-brands></section-brands>
            <banner-newsletter background="/img/background-image-newsletter.jpg"></banner-newsletter>
        </div>
    </app-layout>
</template>

<script>
    import Axios from 'axios';
    import BannerNewsletter from '../components/BannerNewsletter/BannerNewsletter.vue';
    import SectionBrands from './SectionBrands/SectionBrands.vue';
    import AppItinerary from '../components/Itinerary/Itinerary.vue';


    export default {
    components: {
    BannerNewsletter,
    SectionBrands,
    "app-itinerary": AppItinerary


    },
    data() {
        return {
        landing: null,
        itineraries: [],
        itinerarySelected: 0,
        hotelImages: [],
        };
    },
    async beforeRouteEnter(to, from, next) {
        try {
            const { data } = await Axios.get(`/api/${to.params.custom_url}`);
            next(vm => {
                vm.landing = data;

                if (data.itineraries) {
                    vm.itineraries = data.itineraries;
                }
            });
        } catch (error) {
            console.error('❌ Error cargando la landing:', error);
            next();
        }
    },

    methods: {
        updateItinerarySelected(index) {
            this.itinerarySelected = index;
        },
        async fetchHotelImages() {
            if (!this.landing?.code) {
                console.warn('No hay código de destino en landing, deteniendo fetch.');
                return;
            }

            try {
                const { data: images } = await Axios.get(`/api/hotels/${this.landing.code}/images`);
                this.hotelImages = images;
            } catch (error) {
                console.error('Error al obtener imágenes de hoteles:', error);
            }
        },

        scrollToForm() {
        const formElement = document.getElementById('form-container-id');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth' });
        }
    }


    },
    watch: {
        landing: {
        handler(newLanding) {
            if (newLanding && newLanding.code) {
                this.fetchHotelImages();
            } else {
                console.warn('No se encontró código en landing, no se ejecuta fetchHotelImages().');
            }
        },
        deep: true
    }


    }
};

</script>

<style lang="scss">
  .destination-grid-container {
    @media screen and (max-width: 1240px) {
      padding: 40px 1rem;
    }
    padding: 60px 0 0 0;
  }
  .grid-container {
    margin-top: 20px;
    grid-template-columns: 1fr 1fr 1fr;
      .item1 {
          grid-column: 1 / 2;
          grid-row: span 2;
      }

      .item2, .item4 {
          grid-column: 2 / 3;
          grid-row: span 1;
      }

      .item3, .item5 {
          grid-column: 3 / 3;
          grid-row: span 1;
      }

      img {
          width: 100%;
          height: 100%;
          object-fit: cover;
      }
  }

  .hotel-box {
      max-height: 210px;
      max-width: 406px;
  }

  .img-carousel {
      width: 300px;
  }

  .input-box {
    max-width: 400px;
    padding: 30px 20px;
    border-radius: 16px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
     @media screen and (max-width: 768px) {
      max-width: none;
    }
  }

</style>
